import React, { useMemo } from 'react';
import classnames from 'classnames';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from 'react-share';

import { svgWrap } from './styles.module.scss';

const settings = {
  size: 60,
  round: true,
};

const ShareSocials = ({ className = '', uri, title, excerpt }) => {
  const urlToShare = useMemo(() => process.env.GATSBY_WEB_URL + uri, [uri]);

  return (
    <ul className={classnames('flex space-x-3 sm:space-x-5', className)}>
      <li>
        <FacebookShareButton url={urlToShare} title={title} className={svgWrap}>
          <FacebookIcon size={settings.size} round={settings.round} />
        </FacebookShareButton>
      </li>
      <li>
        <TwitterShareButton url={urlToShare} title={title} className={svgWrap}>
          <TwitterIcon size={settings.size} round={settings.round} />
        </TwitterShareButton>
      </li>
      <li>
        <LinkedinShareButton
          url={urlToShare}
          title={title}
          summary={excerpt}
          source={urlToShare}
          className={svgWrap}
        >
          <LinkedinIcon size={settings.size} round={settings.round} />
        </LinkedinShareButton>
      </li>
    </ul>
  );
};

export default ShareSocials;
